import { ReactNode } from 'react';

export const Bold = (chunks: ReactNode[]) => {
  return <b>{chunks}</b>;
};
